import React from 'react';
import PropTypes from 'prop-types';
import * as rights from '../../../../model/rights';
import GenericRow from './GenericRow';

class UserRow extends GenericRow {
  constructor(props) {
    super(props);
  }

  render() {
    return <div className={'row col-md-12'}>
      <div className={'col-md-4'} style={{marginTop: '12px'}}>
        <div style={this.getColumnStyle()}>
          <span>USER</span>
        </div>
      </div>
      <div className={'col-md-8'}>
        {this.getTableDataContent(rights.USER_READ_PRIVILEGE)}
        {this.getTableDataContent(rights.USER_ADD_PRIVILEGE)}
        {this.getTableDataContent(rights.USER_EDIT_PRIVILEGE)}
        {this.getEmptyDataContent()}
        {this.getTableDataContent(rights.USER_DISABLE_PRIVILEGE)}
        {this.getEmptyDataContent()}
      </div>
    </div>;
  }
}

UserRow.propTypes = {
  permissionSection: PropTypes.object,
  onChange: PropTypes.func,
};

export default UserRow;
